document.addEventListener('DOMContentLoaded', function () {
  const collectionsHighlights = document.querySelectorAll('.ed-collections-highlight');

  collectionsHighlights.forEach((collection) => {
    const swiperContainer = collection.querySelector('.collections-highlight-swiper');
    let swiperInstance;

    const initializeSwiper = () => {
      swiperInstance = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 8,
        breakpoints: {
          750: {
            slidesPerView: 2,
          },
        },
      });
    };

    const handleBreakpointChange = () => {
      const viewportWidth = window.innerWidth;

      if (viewportWidth >= 990) {
        if (swiperInstance) {
          swiperInstance.destroy(true, true); // Destroy the Swiper instance
          swiperInstance = null;
        }
      } else if (!swiperInstance) {
        initializeSwiper(); // Reinitialize if needed
      }
    };

    // Initialize on load
    handleBreakpointChange();

    // Add event listener to handle window resize
    window.addEventListener('resize', handleBreakpointChange);
  });
});
